import {
  InlineRovoPromptTriggerSource,
  openInlineRovoPrompt,
} from '@databases/database-ai-first-creation-state/inline-rovo-prompt-state';
import { AskRovoIcon } from '@databases/database-ai-first-creation-ui/icons/ask-rovo-icon';
import { messages } from '@databases/intl/messages';
import React, { useEffect } from 'react';

import { getExperimentValue } from '@canvas/client-feature-flags';

import { type MenuItemBuilder, SELECT_VALUE_MENU_ACTIONS } from '../types';

const RovoElemBefore = () => {
  useEffect(() => {
    getExperimentValue('databasesAIFC', 'enabled', {
      fireExperimentExposure: true,
    });
  }, []);
  return <AskRovoIcon height={16} width={16} noPadding />;
};

export const askRovoMenuItem: MenuItemBuilder = ({
  capabilities: { canAskRovo },
  formatMessage,
}) => ({
  isEnabled: () => canAskRovo,
  menuItem: {
    key: SELECT_VALUE_MENU_ACTIONS.ASK_ROVO,
    content: formatMessage(messages['value-actions.ask-rovo']),
    onClick: () => openInlineRovoPrompt(InlineRovoPromptTriggerSource.TableEntry),
    closeOnClick: true,
    elemBefore: <RovoElemBefore />,
  },
});
